export const SEWERAGE_SYSTEMS_PATH =
  '/uslugi/gotovye-resheniya-pod-klyuch/sistemy-vodosnabzheniya-i-kanalizacii-pod-klyuch/';

export const SEWERAGE_PRELIMINARY_DESIGN_ID = '571';
export const SEWERAGE_WORKING_DOCUMENTATION_ID = '2952';

export const SEWERAGE_SUPPLY_SYSTEMS_CONSULTATION_TYPE = 'WATER_SUPPLY';

export const SEWERAGE_SERVICE_TYPE_ID_LIST = [
  SEWERAGE_PRELIMINARY_DESIGN_ID,
  SEWERAGE_WORKING_DOCUMENTATION_ID,
];

export const SEWERAGE_ELEMENT_BLOCK = 'landingSistemyVodosnabzheniya';

export const SERVICE_ID_SEWERAGE = '2108';
